import { createFileRoute } from "@tanstack/react-router";
import { CategoryListing } from "@/components/venues/CategoryListing";

export const Route = createFileRoute("/_categories/hotels")({
  head: () => ({
    meta: [
      { title: "Premium Hotels & Suites in Oyo State — OyoBooking" },
      {
        name: "description",
        content:
          "Discover, compare and book premium luxury hotels, suites, resorts and serviced apartments across Oyo State, Nigeria.",
      },
    ],
    links: [{ rel: "canonical", href: "https://oyobooking.ng/hotels" }],
  }),
  component: () => <CategoryListing category="hotel" />,
});
